import { record, scalar, upper, type Row } from '../ability/context.js';

export const COIN_GP: Readonly<Record<string, number>> = {
  'DDF5AA5E-BCA8-D5A7-ED03-E9A82356A65E': 10,
  'B0B6D994-03C5-D49A-C1FF-49C3C1723A4E': 1,
  '0AB2A68A-8FDC-AAC3-5E79-D9BA6395A551': 0.5,
  'F52A7C08-B1B3-F1AF-81D5-1919DD4691CA': 0.1,
  'C42F9276-0791-46E0-985A-22B3117096DE': 0.01,
};
export interface PriceReaders {
  inventoryField(row: Row | null, key: string): unknown;
  value(row: Row | null, key: string): unknown;
  itemId(row: Row): string;
  computed(row: Row, group: string, key: string): unknown;
}
const num = (v: unknown): number => Number(scalar(v) ?? 0) || 0;

/** The thumbnail stamp and exchange use exactly one full per-unit price implementation. */
export function inventoryUnitGp(row: Row, read: PriceReaders): number {
  const override = num(read.inventoryField(row, 'inventory_cost_gp'));
  if (override > 0) return override;
  const total = num(read.computed(row, 'cost', 'total_gp'));
  if (total > 0) return total / Math.max(1, num(read.inventoryField(row, 'item_qty')) || 1);
  let gp = num(read.value(row, 'cost_gp')) + num(read.computed(row, 'enchantment', 'total_cost'));
  // ftComputedValue unwraps arrays to their first scalar; this native list uses the thumbnail's existing bucket read.
  const multipliers = record(record(row.computed)?.enchantment)?.cost_multipliers;
  for (const mult of Array.isArray(multipliers) ? multipliers : Object.values(record(multipliers) ?? {})) {
    const n = num(mult); if (n !== 0) gp *= n;
  }
  return gp > 0 ? gp : COIN_GP[upper(read.itemId(row))] ?? 0;
}
